import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import AboutPageContent from "../components/about/about-page";

const AboutPage = () => {
  return (
    <Layout>
      <AboutPageContent />
    </Layout>
  );
};

export default AboutPage;

export const Head = () => <Seo title="About" />;